import "./index.scss";

export function TableComponent({ className, children }: { className?: string; children?: any }) {
  return (
    <div className={`table-container-full box-shadow ${className}`}>
      <table className="table-container-header-body headerTable bodyTable box-title">{children}</table>
    </div>
  );
}

export function THeadTR({ children, className = "", classNameTR = "" }) {
  return (
    <thead className={`text-1.4rem font-medium font-familyPoppins text-left text-textPrimary h-12 border-b-4 border-background ${className}`}>
      <tr className={classNameTR}>{children}</tr>
    </thead>
  );
}

export function TH({ children, className = "" }) {
  return <th className={`pl-5 ${className}`}>{children}</th>;
}
